// 定义 HTML 实体解码函数的可选参数类型。
export interface DecodeHtmlEntitiesOptions {
  // 是否优先使用 DOM 能力进行解码（浏览器环境更完整）。
  preferDom?: boolean;
  // 额外的命名实体映射，用于补充默认映射之外的实体。
  namedEntityMap?: Record<string, string>;
}

// 导出统一的 HTML 实体解码函数。
export const decodeHtmlEntities = (
  // 待解码文本，默认空字符串。
  text = '',
  // 解码选项，默认空对象。
  options: DecodeHtmlEntitiesOptions = {}
) => {
  // 输入为空时直接返回空字符串。
  if (!text) return '';
  // 解析选项并提供默认值。
  const { preferDom = true, namedEntityMap = {} } = options;

  // 在允许且存在 document 的环境中优先走 DOM 解码。
  if (preferDom && typeof document !== 'undefined') {
    // 创建临时容器用于浏览器原生实体解析。
    let temp: HTMLDivElement | null = document.createElement('div');
    // 将原始文本写入 innerHTML 触发实体解析。
    temp.innerHTML = text;
    // 读取解码后的纯文本内容。
    let decoded = temp.textContent || temp.innerText || '';
    // 释放临时对象引用。
    temp = null;
    // 应用额外命名实体映射（处理 DOM 未覆盖或业务自定义实体）。
    Object.entries(namedEntityMap).forEach(([entity, value]) => {
      // 将形如 &entity; 的文本替换成目标字符。
      decoded = decoded.replace(new RegExp(`&${entity};`, 'g'), value);
    });
    // 返回 DOM 分支解码结果。
    return decoded;
  }

  // （兜底方案）在非浏览器或不使用 DOM 时走正则回退解码。
  let decoded = text
    // 还原不换行空格实体。
    .replace(/&nbsp;/g, ' ')
    // 还原与号实体。
    .replace(/&amp;/g, '&')
    // 还原双引号实体。
    .replace(/&quot;/g, '"')
    // 还原单引号实体。
    .replace(/&#39;/g, "'")
    // 还原小于号实体。
    .replace(/&lt;/g, '<')
    // 还原大于号实体。
    .replace(/&gt;/g, '>')
    // 还原十进制数字实体。
    .replace(/&#(\d+);/g, (_, dec) => String.fromCodePoint(Number(dec)))
    // 还原十六进制数字实体。
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) =>
      String.fromCodePoint(parseInt(hex, 16))
    );

  // 应用额外命名实体映射（回退分支）。
  Object.entries(namedEntityMap).forEach(([entity, value]) => {
    // 将形如 &entity; 的文本替换成目标字符。
    decoded = decoded.replace(new RegExp(`&${entity};`, 'g'), value);
  });
  // 返回最终解码结果。
  return decoded;
};
